export default build =>
    build.mutation({
        query(payload) {
            return {
                url: `/exam/deleteDepositProof`,
                method: 'POST',
                body: payload
            };
        },
        invalidatesTags: ['allCashDepositRecordByAgent']

    })
